<template>
  <div class="nczs">
    <div class="title">种植大户</div>
    <title-bar title="种植大户">
      <a-form-model layout="inline">
        <a-form-model-item label="村名">
          <a-input placeholder="请输入村名进行查询" v-model="queryParam.orgName" />
        </a-form-model-item>
        <a-form-model-item label="合作社/农户">
          <a-input placeholder="请输入村名进行查询" v-model="queryParam.name" />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="default" @click="loadData()">搜索</a-button>
        </a-form-model-item>
      </a-form-model>
    </title-bar>
    <a-spin :spinning="loading">
      <a-table rowKey="id" :columns="columns" :data-source="rowData" :pagination="pagination" @change="tableChange">
      </a-table>
    </a-spin>
  </div>
</template>
<script>
import TitleBar from './components/titleBar.vue'
import { PlantingLargePage } from '@/api/main/AgricultureAttractManager.js'
export default {
  components: {
    TitleBar
  },
  data() {
    return {
      loading: false,
      columns: [
        {
          title: '村名',
          dataIndex: 'orgName',
          align: 'center',
          width: 80
        },
        {
          title: '合作社名称或农户姓名',
          dataIndex: 'name',
          align: 'center',
          width: 110
        },
        {
          title: '电话',
          dataIndex: 'phone',
          align: 'center',
          width: 80
        },
        {
          title: '总面积(亩)',
          dataIndex: 'totalArea',
          align: 'center',
          width: 120
        },
        {
          title: '富士(亩)',
          dataIndex: 'fuShiArea',
          align: 'center',
          width: 90
        },
        {
          title: '红将军(亩)',
          dataIndex: 'hongJiangJunArea',
          align: 'center',
          width: 90
        },
        {
          title: '嘎拉(亩)',
          dataIndex: 'gaLaArea',
          align: 'center',
          width: 90
        },
        {
          title: '旺林(亩)',
          dataIndex: 'wangLinArea',
          align: 'center',
          width: 90
        },
        {
          title: '其他苹果(亩)',
          dataIndex: 'orherAppleArea',
          align: 'center',
          width: 90
        },
        {
          title: '丰水(亩)',
          dataIndex: 'fengShuiArea',
          align: 'center',
          width: 90
        },
        {
          title: '丑梨(亩)',
          dataIndex: 'chouLiArea',
          align: 'center',
          width: 90
        },
        {
          title: '其他梨(亩)',
          dataIndex: 'otherPearArea',
          align: 'center',
          width: 90
        },
        {
          title: '夏桃(亩)',
          dataIndex: 'xiaTaoArea',
          align: 'center',
          width: 90
        },
        {
          title: '秋桃(亩)',
          dataIndex: 'qiuTaoArea',
          align: 'center',
          width: 90
        },
        {
          title: '葡萄(亩)',
          dataIndex: 'puTaoArea',
          align: 'center',
          width: 110
        },
        {
          title: '板栗(亩)',
          dataIndex: 'banLiArea',
          align: 'center',
          width: 120
        },
        {
          title: '樱桃(亩)',
          dataIndex: 'yingTaoArea',
          align: 'center',
          width: 90
        },
        {
          title: '西红柿(亩)',
          dataIndex: 'xiHongShiArea',
          align: 'center',
          width: 90
        },
        {
          title: '草莓(亩)',
          dataIndex: 'caoMeiArea',
          align: 'center',
          width: 90
        },
        {
          title: '蔬菜(亩)',
          dataIndex: 'shuCaiArea',
          align: 'center',
          width: 90
        },
        {
          title: '蘑菇(亩)',
          dataIndex: 'moGuArea',
          align: 'center',
          width: 90
        },
        {
          title: '西洋参(亩)',
          dataIndex: 'xiYangShenArea',
          align: 'center',
          width: 90
        },
        {
          title: '经济林木(亩)',
          dataIndex: 'jingJiLinMuArea',
          align: 'center',
          width: 90
        },
        {
          title: '无花果(亩)',
          dataIndex: 'wuHuaGuoArea',
          align: 'center',
          width: 90
        },
        {
          title: '桑葚(亩)',
          dataIndex: 'sangShenArea',
          align: 'center',
          width: 90
        },
        {
          title: '种粮大户(亩)',
          dataIndex: 'zhongLinagDaHuArea',
          align: 'center',
          width: 90
        }
      ],
      rowData: [],
      queryParam: {
        orgName: null,
        name: null,
        pageNo: 1,
        pageSize: 20
      },
      pagination: {
        total: 0,
        pageSize: 20
      }
    }
  },
  methods: {
    loadData() {
      this.loading = true
      PlantingLargePage(this.queryParam)
        .then(res => {
          this.rowData = res.data.pageData.rows
          this.pagination.total = res.data.pageData.totalRows
          this.rowData.push({
            orgName: '合计',
            id: 'hjh',
            ...res.data.sumData[0]
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    tableChange(pagination) {
      this.queryParam.pageNo = pagination.current
      this.loadData()
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
<style lang="less">
.nczs {
  .title {
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #000;
  }
  .right .ant-form-item label {
    color: #fff !important;
  }
  .ant-empty-normal {
    margin: 140px 0 !important;
  }
  .ant-table-body {
    overflow: auto;
    min-height: 352px !important;

    .ant-table-row-cell-break-word {
      color: #000 !important;
    }
    .ant-table-row:last-child {
      .ant-table-row-cell-break-word {
        font-weight: bold;
      }
    }
  }
  .ant-table-placeholder {
    display: none;
  }
}
</style>
